import { pad2, parseIsoDateTime } from "./isoDate";

/** `Date.getDay()`: 0 = воскресенье */
export const WEEKDAY_SHORT_RU = [
  "вс",
  "пн",
  "вт",
  "ср",
  "чт",
  "пт",
  "сб",
] as const;

export function parseAnswerDate(value: string): Date | null {
  const trimmed = value.trim();
  if (!trimmed) return null;
  if (/[zZ]|[+-]\d{2}:\d{2}$/.test(trimmed)) {
    const parsed = new Date(trimmed);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }
  const fromIso = parseIsoDateTime(trimmed);
  if (fromIso) return fromIso;
  const parsed = new Date(trimmed);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function formatDottedDate(
  date: Date,
  options?: { includeYear?: boolean },
): string {
  const dayMonth = `${pad2(date.getDate())}.${pad2(date.getMonth() + 1)}`;
  if (options?.includeYear === false) return dayMonth;
  return `${dayMonth}.${date.getFullYear()}`;
}

function hasClockTime(value: string): boolean {
  return /T\d{2}:\d{2}|\s\d{2}:\d{2}/.test(value.trim());
}

/**
 * Дата ответа и дата/время в таблице:
 * `11.09 13:00 (пт)` в текущем году, `24.09.1992 13:00 (чт)` иначе.
 */
export function formatAnswerTimestamp(
  value: string | Date | null | undefined,
  options?: { now?: Date; withTime?: boolean },
): string {
  if (value == null || value === "") return "—";
  const raw = value instanceof Date ? "" : String(value);
  const date = value instanceof Date ? value : parseAnswerDate(raw);
  if (!date) return raw.trim() || "—";

  const now = options?.now ?? new Date();
  const includeYear = date.getFullYear() !== now.getFullYear();
  const datePart = formatDottedDate(date, { includeYear });
  const weekday = WEEKDAY_SHORT_RU[date.getDay()];
  const withTime = options?.withTime ?? (raw ? hasClockTime(raw) : true);

  if (!withTime) return `${datePart} (${weekday})`;
  return `${datePart} ${pad2(date.getHours())}:${pad2(date.getMinutes())} (${weekday})`;
}

/** Ячейка поля date: всегда с годом, время — `24.09.1992 13:00`. */
export function formatTableDateValue(
  value: string,
  withTime: boolean,
): string | null {
  const date = parseAnswerDate(value);
  if (!date) return null;
  const datePart = formatDottedDate(date);
  if (!withTime) return datePart;
  return `${datePart} ${pad2(date.getHours())}:${pad2(date.getMinutes())}`;
}
